import { useState, useCallback, useEffect } from 'react';
import { connect } from 'react-redux';

import PopupWindow from './PopupWindow';
import PushButton from './PushButton';
import { UNPUBLISH_SCHEDULE } from '../actions/types';
import { siteboardAction, setUnpublishScheduleDialogueId } from '../actions/defaultActions';
import { format } from 'date-fns';
import { Timestamp } from '../actions/types.mjs';

const UnpublishScheduleDialogue = ({ _users, _projects, _schedules, _unpublishScheduleDialogueId, setUnpublishScheduleDialogueId, siteboardAction }) => {

  const closeDialogue = useCallback(() => {
    setUnpublishScheduleDialogueId(null);
  }, [setUnpublishScheduleDialogueId]);

  const selectedSchedule = _schedules[_unpublishScheduleDialogueId];
  if(selectedSchedule === undefined) return (<></>);

  const selectedProject = _projects[selectedSchedule.projectId];
  if(selectedProject === undefined) return (<></>);

  const getPublishedByLine = () => {
    let text = '';
    try {
      Timestamp.validate(selectedSchedule.publishedTimestamp);
      if(selectedSchedule.publishedTimestamp === 0) throw new Error();
      text += 'This schedule was published on ' + format(selectedSchedule.publishedTimestamp, 'MM/dd/yyyy');
      text += ' by ' + _users[selectedSchedule.publishedByUserId].firstName + ' ' + _users[selectedSchedule.publishedByUserId].lastName + ' (' + _users[selectedSchedule.publishedByUserId].email + ').';
    } catch(error) {}
    return text;
  };

  return (
    <PopupWindow title='Unpublish 3-Week' closeDialogue={closeDialogue} bgStyle='bg-[#333]'>
      <div className='max-w-[400px] bg-[#333] text-white'>
        <div className=''>
          Unpublish this 3-week schedule for project <b>"{selectedProject.name}"</b> starting on <b>{selectedSchedule.beginDate}</b>?
        </div>
        <div className='mt-5'>
          {getPublishedByLine()}
        </div>
        <div className='mt-5'>
          Once unpublished this schedule can be modified or deleted.
        </div>
        <div className='flex flex-col justify-center mt-5'>
          {/* unpublish button  */}
          <div className='flex justify-center'>
            <PushButton 
              textColor='white'
              bgColor='#471cff'
              hoverBgColor='#603aff'
              onClick={() => {
                siteboardAction(UNPUBLISH_SCHEDULE, {
                  scheduleId: selectedSchedule.id,
                  projectId: selectedProject.id,
                  subscriptionId: selectedProject.subscriptionId,
                }, (output) => { closeDialogue(); });
              }}
            >
              <div className='flex items-center gap-x-[6px]'>
                <div>Unpublish 3-Week Schedule</div>
              </div>
            </PushButton>
          </div>
        </div>
      </div>
    </PopupWindow>
  );
};

// define redux state that will be passed in as props
const mapStateToProps = state => { return {
  _users: state.serverSynced.users,
  _projects: state.serverSynced.projects,
  _schedules: state.serverSynced.schedules,
  _unpublishScheduleDialogueId: state.localEphemeral.unpublishScheduleDialogueId,
}};
export default connect(mapStateToProps, { siteboardAction, setUnpublishScheduleDialogueId })(UnpublishScheduleDialogue);
